import { render } from "./TypeView.vue?vue&type=template&id=235a57e1&scoped=true"
import script from "./TypeView.vue?vue&type=script&lang=js"
export * from "./TypeView.vue?vue&type=script&lang=js"

import "./TypeView.vue?vue&type=style&index=0&id=235a57e1&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235a57e1"]])

export default __exports__